import React, { useEffect, useState } from "react";
import DataTable from "../../common/DataTable";
import { LedgerListing, numOfPage } from "../../../constant";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import BatchPagination from "../../batch/BatchPagination";
import _ from "lodash";
import { fetchLedgerListing } from "../../../store/actions/accounts.action";
import ProductListingFilter from "../../Inventory/Product/ProductListingFilter";
import LoaderSpinner from "../../common/Loader";
import moment from "moment";
import SearchCarrierConnect from "../../CarrierConnect/SearchCarrierConnect";
import { ledgerBackDetails } from "../../../store/actions/employee";

/* istanbul ignore next */
const LedgerList = () => {
    const location = useLocation();
    const [locationData] = useState(location?.state || {});
    const { ledgerData, ledgerListStatus } = useSelector((state) => state.accountingReducer);
    const [loader, setLoader] = useState(false);
    const [sellerList, setSellerList] = useState([]);
    const [allSellers, setAllSellers] = useState([]);
    const [resetTrigger, setResetTrigger] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { ledgerPrevState } = useSelector((state) => state.employee);

    useEffect(() => {
        if (ledgerListStatus === "PENDING") {
            setLoader(true);
        } else if (ledgerListStatus === "SUCCESS") {
            setLoader(false);
            setfilterData({
                ...filterData,
                totalPages: Math.ceil(ledgerData.TotalRecords / filterData.pageSize),
            });
        }
    }, [ledgerListStatus]);

    let payloadData = {
        pageIndex: 1,
        pageSize: 30,
        totalPages: 1,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        searchText: '',
        sellerIdList: locationData.sellerId ? [{ id: locationData.sellerId, value: locationData.sellerId, label: locationData.sellerName }] : [],
        companyIdList: locationData.companyId ? [{ Id: locationData.companyId, value: locationData.companyId, label: locationData.companyName }] : [],
        showFilter: false,
        showSearch: false,
        startDate: null,
        endDate: null,
    }

    const [filterData, setfilterData] = useState({});


    useEffect(() => {
        if (!_.isEmpty(ledgerPrevState)) {
            setfilterData({ ...filterData, ...ledgerPrevState });
        } else {
            setfilterData({ ...payloadData });
        }
    }, []);

    const fetchLedgerList = (dataParam = null) => {
        const source = dataParam || filterData;
        let data = {
            ...source,
            companyIdList: _.map(source.companyIdList, "Id"),
            sellerIdList: _.map(source.sellerIdList, "id"),
            statusIdList: _.map(source.statusIdList, "id"),
            transactionModeIdList: _.map(source.transactionModeIdList, "id"),
            transactionTypeIdList: _.map(source.transactionTypeIdList, "id"),
            searchText: source.searchText.trim(),
        };

        dispatch(fetchLedgerListing(data));
    };

    useEffect(() => {
        if (!_.isEmpty(filterData)) {
            fetchLedgerList();
        }
    }, [filterData.pageSize, filterData.pageIndex, filterData.sortColumn, filterData.sortOrder, resetTrigger]);

    const handleAction = (item, type) => {
        dispatch(ledgerBackDetails({ ...filterData }));
        navigate(`/accounting/ledger/${item.id}`, {
            state: {
                rateCardDetails: item,
                editable: type === 'view' ? false : true,
                isAddEntry: type === 'makeEntry' ? true : false
            }
        });
    };

    const handleSortingColumn = (key) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        setfilterData({
            ...filterData,
            pageIndex: 1,
            sortColumn: key,
            sortOrder: newSortOrder,
        });
    };

    const handlePayNow = () => {
        navigate('/payment');
    };

    const createNewLedger = () => {
        navigate('/accounting/ledger/0', {
            state: {
                editable: true,
            }
        });
    };

    const handleSearchText = (value) => {
        setfilterData({
            ...filterData,
            searchText: value
        })
    };

    const handleReset = () => {
        setfilterData(prev => {
            const updated = { ...prev, pageIndex: 1, searchText: '' };
            fetchLedgerList(updated);
            return updated;
        });
    };

    const handleFilterReset = () => {
        setfilterData({ ...payloadData, companyIdList: [], sellerIdList: [] });
        setResetTrigger(prev => prev + 1); // force rerun
    };

    const handleDateFieldChange = (date, fieldName) => {
        setfilterData({
            ...filterData,
            [fieldName]: moment(date).format("YYYY-MM-DDTHH:mm:ss"),
        });
    };

    const handleSearchFilter = () => {
        setfilterData({ ...filterData, pageIndex: 1 });
        if (filterData.pageIndex === 1) {
            fetchLedgerList();
        }
    }

    const handleFilter = () => {
        let cloneFilterData = {
            ...filterData,
            companyIdList: _.map(filterData.companyIdList, 'Id'),
            sellerIdList: _.map(filterData.sellerIdList, 'id'),
            pageIndex: 1,
        };
        if (filterData.pageIndex !== 1) {
            setfilterData({ ...filterData, pageIndex: 1 });
        } else {
            dispatch(fetchLedgerListing(cloneFilterData));
        }
    };

    return (
        <>
            <div className="main__tile_heading cus-btn-include-sec zIndex2">
                <span>
                    Ledger
                </span>
                <div className='inlineFlex fontFix'>
                    <div className='filterBtnWapper'>
                        <button className="btn cus-seconday-bg-btn" onClick={createNewLedger}>
                            Create
                        </button>
                        <button className="btn cus-seconday-bg-btn openSearch ml-2" onClick={() => setfilterData({ ...filterData, showFilter: !filterData.showFilter })}>
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            {filterData.showFilter && (
                <ProductListingFilter
                    showFilter={filterData.showFilter}
                    dispatch={dispatch}
                    useSelector={useSelector}
                    filterData={filterData}
                    setfilterData={setfilterData}
                    fetchProductList={handleFilter}
                    handleReset={handleFilterReset}
                    sellerList={sellerList}
                    setSellerList={setSellerList}
                    allSellers={allSellers}
                    setAllSellers={setAllSellers}
                    handleDateFieldChange={handleDateFieldChange}
                    type="ledger"
                />
            )}

            <div className='zIndex2'>
                <SearchCarrierConnect
                    searchKeyword={filterData.searchText}
                    handleSearchText={handleSearchText}
                    handleSearchFilter={handleSearchFilter}
                    handleReset={handleReset}
                    placeholderText="Search by Company, Seller, Reference or Description"
                />
            </div>
            {loader && <LoaderSpinner />}


            <div className="main_content_table_history">
                <div className="tableFixHead incomingTbl">
                    <div className="incomingTbl p-3">
                        <DataTable
                            headers={LedgerListing}
                            tableData={ledgerData.ledgerList || []}
                            actionType={10}
                            handleAction={handleAction}
                            handleSortingColumn={handleSortingColumn}
                            showPayNow={handlePayNow}
                            dataStatus={ledgerListStatus}
                            filterData={filterData}
                        />
                    </div>
                </div>
            </div>

            <BatchPagination
                gridData={ledgerData.ledgerList || []}
                totalVisualRecords={ledgerData?.ledgerList?.length || 0}
                numberOfPage={filterData.pageSize}
                numOfPage={numOfPage}
                loader={loader}
                currentPage={filterData.pageIndex}
                totalPages={filterData.totalPages}
                totalRecords={ledgerData.TotalRecords}
                setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
            />
        </>
    )
};
export default LedgerList;